import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=3dc89c94&"
import script from "./SimpleCard.vue?vue&type=script&lang=ts&"
export * from "./SimpleCard.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports